(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name messageAdmin.factory:MessageAdminAdaptorFactory
   *
   * @description
   *
   */
  angular
    .module('messageAdmin')
    .factory('MessageAdminAdaptorFactory', MessageAdminAdaptorFactory);

  function MessageAdminAdaptorFactory() {

    function adaptFormSubmit(formData, jsonData) {
      if(!!!formData){
        formData = new FormData();
      }
      if(formData.get('message')){
        formData.delete('message');
      }
      formData.append('message', JSON.stringify(jsonData));
      return formData
    }

    return {
      adaptFormSubmit: adaptFormSubmit
    }
  }
})();
